import React from 'react';
import { Grid, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import styles from '../analytics.module.css';
import commonStyles from '../../common/common.module.css';
import { number } from '../../../utils/dataFormats';

import CustomerWaitAverage from '../../../models/Analytics';

interface AverageeProps {
  average: CustomerWaitAverage;
  type: string;
  handleChange: (type: string, event: any) => void;
};

const Average = (props: AverageeProps) => {
  const { average } = props;

  return (
    <div className={`${styles.customerGridItems}`}>
      <Grid container spacing={3} className={`${styles.wtOuterGridContainer}`}>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
          <div className={`${styles.wtOuterGridItems} ${commonStyles.fColumnjcEnd} ${commonStyles.h100}`}>
            <h5 className={styles.heading}> Average Wait Time (mins)</h5>
            <Grid container justifyContent="center" spacing={2} className={`${styles.wtGridContainer} ${styles.avgContainer} ${commonStyles.mtauto}`} >
              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Wait For Service</span>
                  <span className={`${styles.blockData}`}>{number(average.cont_wait)}</span>
                </div>
              </Grid>

              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Counter Process</span>
                  <span className={`${styles.blockData}`}>{number(average.cont_pros)}</span>
                </div>
              </Grid>

              {/* <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>W/hse Wait</span>
                  <span className={`${styles.blockData}`}>{number(average.whse_wait)}</span>
                </div>
              </Grid> */}

              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>W/hse Process</span>
                  <span className={`${styles.blockData}`}>{number(average.whse_pros)}</span>
                </div>
              </Grid>

              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Total</span>
                  <span className={`${styles.blockData}`}>{number(average.total)}</span>
                </div>
              </Grid>

            </Grid>
          </div>

        </Grid>

        <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
          <div className={`${styles.wtOuterGridItems} ${commonStyles.fColumnjcEnd} ${commonStyles.h100}`}>
            <h5 className={styles.heading}> Shortest/Longest Wait Time</h5>
            <Grid container spacing={2} className={`${styles.wtGridContainer} ${styles.srtLngContainer} ${commonStyles.mtauto}`}>
              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Shortest</span>
                  <span className={`${styles.blockData}`}>{number(average.short_time)}</span>
                </div>
              </Grid>

              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Longest</span>
                  <span className={`${styles.blockData}`}>{number(average.long_time)}</span>
                </div>
              </Grid>

            </Grid>
          </div>
        </Grid>

        <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
          <div className={`${styles.wtOuterGridItems} ${commonStyles.fColumnjcEnd} ${styles.detailsContainer} ${commonStyles.h100}`}>
            <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap}`}>
              <h5 className={`${styles.heading} ${commonStyles.spaceNowrap}`}>Details per order</h5>
              <RadioGroup
                row
                name="type"
                className={`${styles.perOrderRG}`}>
                <FormControlLabel
                  checked={props.type === 'MIN'}
                  onClick={() => props.handleChange('type', 'MIN')}
                  control={
                    <Radio
                      color="primary"
                      size="small"
                      value='MIN'
                      disableRipple={true}
                      classes={{ root: styles.pORadioIcon }}
                    />
                  }
                  label="Min"
                  classes={{ root: styles.perOrderRadio }}
                />
                <FormControlLabel
                  checked={props.type === 'AVG'}
                  onClick={() => props.handleChange('type', 'AVG')}
                  control={
                    <Radio
                      color="primary"
                      size="small"
                      value='AVG'
                      disableRipple={true}
                      classes={{ root: styles.pORadioIcon }}
                    />
                  }
                  label="Avg"
                  classes={{ root: styles.perOrderRadio }}
                />
                <FormControlLabel
                  checked={props.type === 'MAX'}
                  onClick={() => props.handleChange('type', 'MAX')}
                  control={
                    <Radio
                      color="primary"
                      size="small"
                      value='MAX'
                      disableRipple={true}
                      classes={{ root: styles.pORadioIcon }}
                    />
                  }
                  label="Max"
                  classes={{ root: styles.perOrderRadio }}
                />
              </RadioGroup>
            </div>

            <Grid container spacing={2} className={`${styles.wtGridContainer} ${commonStyles.mtauto}`}>
              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Awbs</span>
                  <span className={`${styles.blockData}`}>{props.type == 'MIN' ? average.awb_min : (props.type == 'MAX' ? average.awb_max : average.awb_avg)}</span>
                </div>
              </Grid>

              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Pieces</span>
                  <span className={`${styles.blockData}`}>{props.type == 'MIN' ? average.pcs_min : (props.type == 'MAX' ? average.pcs_max : average.pcs_avg)}</span>
                </div>
              </Grid>

              <Grid item xs className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Weight</span>
                  <span className={`${styles.blockData}`}>{props.type == 'MIN' ? average.wgt_min : (props.type == 'MAX' ? average.wgt_max : average.wgt_avg)}</span>
                </div>
              </Grid>

            </Grid>
          </div>
        </Grid>

        {/* <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
          <div className={`${styles.wtOuterGridItems}`}>
            <h5 className={styles.heading}>Awbs per order</h5>
            <Grid container spacing={2} className={`${styles.wtGridContainer}`}>
              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Min</span>
                  <span className={`${styles.blockData}`}>{number(average.awb_min)}</span>
                </div>
              </Grid>

              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Avg</span>
                  <span className={`${styles.blockData}`}>{number(average.awb_avg)}</span>
                </div>
              </Grid>

              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Max</span>
                  <span className={`${styles.blockData}`}>{number(average.awb_max)}</span>
                </div>
              </Grid>

            </Grid>
          </div>
        </Grid>

        <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
          <div className={`${styles.wtOuterGridItems}`}>
            <h5 className={styles.heading}>Pieces per order</h5>
            <Grid container spacing={2} className={`${styles.wtGridContainer}`}>
              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Min</span>
                  <span className={`${styles.blockData}`}>{number(average.pcs_min)}</span>
                </div>
              </Grid>

              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Avg</span>
                  <span className={`${styles.blockData}`}>{number(average.pcs_avg)}</span>
                </div>
              </Grid>

              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Max</span>
                  <span className={`${styles.blockData}`}>{number(average.pcs_max)}</span>
                </div>
              </Grid>

            </Grid>
          </div>
        </Grid>

        <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
          <div className={`${styles.wtOuterGridItems}`}>
            <h5 className={styles.heading}>Weight per order</h5>
            <Grid container spacing={2} className={`${styles.wtGridContainer}`}>
              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Min</span>
                  <span className={`${styles.blockData}`}>{number(average.wgt_min)}</span>
                </div>
              </Grid>

              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Avg</span>
                  <span className={`${styles.blockData}`}>{number(average.wgt_avg)}</span>
                </div>
              </Grid>

              <Grid item md={4} sm={6} xs={12} className={`${styles.wtGridItems}`}>
                <div className={`${styles.block}`}>
                  <span className={`${styles.blockTitle}`}>Max</span>
                  <span className={`${styles.blockData}`}>{number(average.wgt_max)}</span>
                </div>
              </Grid>

            </Grid>
          </div>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default Average;